import { Labels, SeriesConfig, TimeSeriesValueTuple } from '@chronosphereio/viz-framework-core';
import { QueryMetadata, SupportedData } from './query';

export interface SingleValue {
  name: string;
  value: number | null;
  formattedName?: string;
  labels?: Labels;
  config?: SeriesConfig;
}

export interface SingleValueData {
  values: SingleValue[];
  metadata?: QueryMetadata;
}

// This primarily supports stat chart with sparkline, requiring both single-value and time series data
export interface SingleValueTimeSeries {
  name: string;
  value: number | null;
  timeSeries: TimeSeriesValueTuple[]; // used to populate sparkline
  formattedName?: string;
  labels?: Labels;
  config?: SeriesConfig;
}

export interface SingleValueTimeSeriesData {
  values: SingleValueTimeSeries[];
  metadata?: QueryMetadata;
}

export function isSingleValueData(data: SupportedData): data is SingleValueData | SingleValueTimeSeriesData {
  return 'values' in data && Array.isArray(data.values);
}
